module.exports = __webpack_public_path__ + "static/img/2027_phase_function_Paper_PointsHejduk_Prediction.d203204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2027_phase_function_Paper_PointsHejduk_Prediction.png
// module id = W+xn
// module chunks = 0